// Error.jsx (Optimized for 404 Not Found Page)

import React, { useEffect } from "react";
import PropTypes from "prop-types";
// Import Link if using React Router for navigation
import { Link } from "react-router-dom";
// Import the CSS module for styling
import styles from "./Error.module.css";

/**
 * A component displayed when a requested route is not found (HTTP 404 error).
 * It provides a clear visual indication of the error and a link to navigate
 * back to the application's homepage.
 */
const Error = ({ className }) => {
  // Set the document title to reflect the 404 error when the component mounts.
  // This runs only once.
  useEffect(() => {
    document.title = "404 - Page Not Found";

    // Optional: Return a cleanup function if you need to reset the title
    // when the component unmounts (e.g., if navigating within a single page app)
    // return () => {
    //   document.title = 'Your Default App Title'; // Replace with your app's default title
    // };
  }, []); // Empty dependency array ensures this effect runs only once on mount

  // Combine the base CSS module class with any additional className passed via props
  const containerClasses = `${styles.container} ${className || ""}`.trim();

  return (
    <div className={containerClasses}>
      {/* Large prominent 404 status code */}
      <h1 className={styles.statusCode}>404</h1>

      {/* User-friendly title indicating the error */}
      <h2 className={styles.title}>Oops! Page Not Found</h2>

      {/* Informative message explaining the situation */}
      <p className={styles.message}>
        Sorry, the page you are looking for doesn't seem to exist. It might have
        been moved, deleted, or maybe the URL was mistyped.
      </p>

      {/* Action link to guide the user back to the homepage */}
      {/* IMPORTANT: Replace <Link> with <a href="/"> if NOT using React Router */}
      <Link to='/' className={styles.homeLink}>
        Go Back Home
      </Link>
    </div>
  );
};

// Define PropTypes for type checking during development
Error.propTypes = {
  /**
   * Allows passing custom CSS classes from the parent (e.g., router)
   * for additional layout adjustments or styling.
   */
  className: PropTypes.string,
};

// Define default props for optional props
Error.defaultProps = {
  className: "", // Default to no extra classes
};

// Export the component for use in your routing setup
export default Error;
